export const TYPE_UNITEL_REVENUE = "TYPE_UNITEL_REVENUE";
export const TYPE_VM_UNITEL = "TYPE_VM_UNITEL";
